import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CasinoReturn as Place, takeCasinoReturn } from 'lib/casinoReturn';

/** Back from a live casino game that took the whole page (see
 *  lib/casinoReturn): the same list, scrolled where the player left it. */
let started: Place | null | undefined;

export function CasinoReturn() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  // Safari can bring the casino page back as it was left (its back-forward
  // cache): nothing to restore then, and the saved place must not send a
  // later start of the app to the casino.
  useEffect(() => {
    const onShow = (e: PageTransitionEvent) => {
      if (e.persisted) takeCasinoReturn();
    };
    window.addEventListener('pageshow', onShow);
    return () => window.removeEventListener('pageshow', onShow);
  }, []);
  useEffect(() => {
    // Read once per start of the app (React may run this twice in a row).
    if (started === undefined) started = takeCasinoReturn();
    const r = started;
    if (!r) return;
    const here = window.location.pathname + window.location.search;
    // An iPhone home-screen app comes back at its start page.
    if (here !== r.path && pathname === '/') {
      navigate(r.path, { replace: true });
    } else if (here !== r.path) {
      return;
    }
    // The list loads after the page, and a new page starts at the top:
    // keep the place for a moment once the list is long enough.
    let tries = 0;
    let held = 0;
    const timer = window.setInterval(() => {
      tries += 1;
      const room = document.documentElement.scrollHeight - window.innerHeight;
      const there =
        window.location.pathname + window.location.search === r.path;
      if (there && (room >= r.scrollY || tries > 30)) {
        window.scrollTo(0, r.scrollY);
        held += 1;
      }
      if (held >= 6 || tries > 40) window.clearInterval(timer);
    }, 150);
    return () => window.clearInterval(timer);
    // once, on the app's start
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}
